import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AssetComponent from "components/core/asset/asset-component";
import { StyledPlatformInteractionComponent } from "./platform-interaction-component.scss";
export default function PlatformInteractionComponent(props) {
    const { image, position, rippleEffectAnimationDuration, onInteractionClick, className } = props;
    return /*#__PURE__*/ _jsx(StyledPlatformInteractionComponent, {
        position: position,
        rippleEffectAnimationDuration: rippleEffectAnimationDuration,
        dimentions: {
            width: image === null || image === void 0 ? void 0 : image.width
        },
        className: `platform-interaction-component ${className}`,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "interaction-wrapper",
            onClick: onInteractionClick,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "image-mode-container",
                    children: /*#__PURE__*/ _jsx(AssetComponent, {
                        image: {
                            src: image === null || image === void 0 ? void 0 : image.src
                        }
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "ripple-container",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "ripple-border ripple-one"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "ripple-border ripple-two"
                        })
                    ]
                })
            ]
        })
    });
}
